import { EpisodeV4 } from "@/types/MentionCard";
import { createContext, useContext, useState } from "react";

type EpisodeId = EpisodeV4["id"];

type MentionCardsContextType = {
  activeEpisodeId?: EpisodeId;
  setActiveEpisodeId: (episodeId: EpisodeId) => void;
};

const MentionCardsContext = createContext<MentionCardsContextType>({
  activeEpisodeId: undefined,
  setActiveEpisodeId: () => undefined,
});

export const useMentionCardsContext = () => {
  return useContext(MentionCardsContext);
};

export const MentionCardsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [activeEpisodeId, setActiveEpisodeId] = useState<EpisodeId>();

  return (
    <MentionCardsContext.Provider
      value={{
        activeEpisodeId,
        setActiveEpisodeId,
      }}
    >
      {children}
    </MentionCardsContext.Provider>
  );
};
